/* FullScreenSpaLoader.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VWP8C%7Bheight%3A100vh%7D%0A._2fBhteCmXr%7Banimation%3Aloading%202s%20infinite%7D");

import React from 'react';
import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
const styles = {
  spaLoader: "_0jFU0VWP8C",
  logo: "_2fBhteCmXr"
};
export const FullScreenSpaLoader = (): React.JSX.Element => <Inline alignBlock="center" alignInline="center" grow="fill" xcss={styles.spaLoader} testId="full-screen-spa-loader">
		<Box xcss={styles.logo}>
			<AtlassianIcon appearance="brand" size="xlarge" />
		</Box>
	</Inline>;